/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Disclaimer_TitleInputs */

const es_components_file_tree_disclaimer_title = /** @type {(inputs: Components_File_Tree_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimación de almacenamiento:`)
};

const en_components_file_tree_disclaimer_title = /** @type {(inputs: Components_File_Tree_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage estimate:`)
};

/**
* | output |
* | --- |
* | "Storage estimate:" |
*
* @param {Components_File_Tree_Disclaimer_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_disclaimer_title = /** @type {((inputs?: Components_File_Tree_Disclaimer_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Disclaimer_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_disclaimer_title(inputs)
	return en_components_file_tree_disclaimer_title(inputs)
});
export { components_file_tree_disclaimer_title as "components.file_tree.disclaimer_title" }